export default __webpack_public_path__ + "static/media/computer.eece371b.png";